/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { BaseUser } from "src/classes/user";
import { ThumbnailGrid } from "src/components/Home/PagesThumbnailGrid";

interface Props {
  user: BaseUser;
}
export default function UserPlates({ user }: Props) {
  const plates = user.observe((state) => state.plates);
  return <ThumbnailGrid plates={plates} />;
}
